import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconClose = ({
  title = "Close",
  color = "darkerRed",
  viewBoxWidth = 20,
  viewBoxHeight = 20,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, color, ...otherProps }}>
    <path
      d="M18 0l2 2-8 8 8 8-2 2-8-8-8 8-2-2 8-8-8-8 2-2 8 8z"
      fill={uiColorToBaseColor(color)}
      fillRule="evenodd"
    />
  </Svg.Icon>
)

export default IconClose
